import { Flair } from '@breakroom-nx/classes';

export enum InputType {
  Text = 'Text',
  Phone = 'Phone',
  Email = 'Email',
  Username = 'Username',
  Password = 'Password',
  Name = 'Full Name',
  Code = 'Code',
  AlphaCode = 'Alpha Invite Code',
}

export enum FlairType {
  // MUST BE DESCENDING BY FLAIR VALUE/RARITY
  Leader = 'Leader',
  Saver = 'Saver',
}

export type RoomMember = {
  uid: string;
  flair?: Flair;
  isHost: boolean;
  username: string;
  // avatar: string;
  // geoCode: string;
};

export enum AccountType {
  Public = 'Public',
  Anonymous = 'Anonymous',
}

export type Coordinate = {
  latitude: number;
  longitude: number;
};

export type Region = {
  latitude: number;
  longitude: number;
  latitudeDelta: number;
  longitudeDelta: number;
};

export type GeoData = {
  city: string;
  country: string;
  code: string;
};

export enum FriendState {
  Friend = 'Remove Friend',
  NotFriend = 'Add Friend',
  RequestSent = 'Cancel Request',
  InvitePendingClientApproval = 'Accept Friend Request',
}

export enum Status {
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning',
}

export enum EntityBeingReported {
  Room,
  User,
}

export enum ChatType {
  Public = 'Public',
  Private = 'Private',
}

export enum NotificationType {
  System = 'System',
  Friend = 'Friend Request',
  Chat = 'Chat Invite',
}

export enum Page {
  Profile = 'Random',
  Settings = 'Settings',
  Updates = 'Updates',
  Suggestions = 'Suggestions',
}

export enum PermissionType {
  Cookies = 'Cookies',
  Location = 'Location',
  Notifications = 'Notification',
}

export enum PermissionStatus {
  NotSet = 'Enable Permission',
  Enabled = "You're All Set!",
  Disabled = 'Disabled',
}

export enum FeedbackType {
  Suggestion = 'Suggestion',
  Bug = 'Bug',
}

export enum ReportOptions {
  OffensiveContent = 'Offensive Content',
  Spam = 'Spamming the App',
  Promotion = 'Self-promotion',
  Catfishing = 'Catfishing / Fake Identity',
  Harassment = 'Harassment',
  Other = 'Other',
}
